import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { DatsState } from './types/index';

export { namespace } from './types/index';

export const state: DatsState = {
  datsState: {
    loading: {
      files: false,
      active: false
    },
    error: {
      files: false,
      active: false
    },
    fetched: {
      files: true,
      active: false
    }
  },
  dats: [],
  errorMessage: '',
  notification: undefined
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
